
import * as React from 'react';
import './styles.scss';
const classNames = require('classnames')
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
    getActivityOpenDiaries,
    getActivityNotifications,
    showTooltip,
    hideTooltip,
    closeActivityFromWeb, 
    changeDiarieDueDate,
    changeDiarieTitle,
    resetCloseActivityState
} from "../../containers/WorkkardDetail/actions/action";
import EditableHeading from "../EditableHeading";
import DiaryEditDueDateComp from './editDiaryDueDate';
import ConfirmationTextBox from '../ConfirmationPrompt';
import NotificationCell from '../../containers/Header/Notification/notificationCell';
import { MiddlePanelConstant, CLOSE_ACTIVITY_ERROR_VALIDATION_MESSAGE, LOGGED_IN_USER_ID ,openDiaryTitle, ErrorCode} from "../../containers/WorkkardDetail/constants";
import { hideDialogueBox } from "../DialogueBox/actions";
import Icon from "../../icons";
import { addClass, removeClass, mobileAndTabletcheck } from '../../common/util';
import CheckBox from '../Checkbox';
import { isMobile } from '../../common/util';
import UserImage from '../UserImage/index';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';


let defaultJSON = require("../../i18n/default.json");

let getItem = (elem, elemArray) => {
    return { ...elem, checked: elemArray.indexOf((elem.Id)) > -1 };
};

function getIdsArrAndModifiedObj(inArray) {
    inArray = JSON.parse(JSON.stringify(inArray));
    let tmpObj = {};
    let id = null;
    let tmpArr = [];
    _.forEach(inArray, function (item) {
        id = (item.Id) ? item.Id : item.id;
        tmpArr.push(id);
        tmpObj[id] = item;
    });
    return { idArr: tmpArr, obj: tmpObj };
}

const CloseActivity = (props) => {
    const dispatch = useDispatch();
    const closeActivity = useSelector(state => state.workkardDetail.closeActivity);
        const sessionContext = useSelector(selectSessionContextOidc);
        const userView = sessionContext?.userView;
        const userPermission = userView?.permissions;

    const requestPayloadRef = React.useRef({});
    const diaryMasterDataRef = React.useRef({});
    const notificationMasterDataRef = React.useRef({});
    const tmpRef = React.useRef(null);

    const [closingItems, setClosingItems] = React.useState([
        { title: "Open Diaries", key: 'diary', iconName: 'diaries', count: 0 },
        { title: "Unread Notifications", key: 'notification', iconName: 'bell', count: 0 }
    ]);
    const [selectedTab, setSelectedTab] = React.useState('diary');
    const [isActionDenied, setIsActionDenied] = React.useState(false);
    const [selectedDiaries, setSelectedDiaries] = React.useState([]);
    const [selectedNotification, setSelectedNotification] = React.useState([]);
    const [diariesData, setDiariesData] = React.useState({});
    const [closeActivityConfimationMessage, setCloseActivityConfimationMessage] = React.useState("");
    const [closeActivityWarningMessage, setCloseActivityWarningMessage] = React.useState("");
    const [closeActivityErrorMessage, setCloseActivityErrorMessage] = React.useState("");
    const [actionDeniedMsg, setActionDeniedMsg] = React.useState("");
    const [editDiaryTitle, setEditDiaryTitle] = React.useState(0);
    const [ownerassigneeinfokey, setOwnerassigneeinfokey] = React.useState(-1);

    const prevCloseActivityRef = React.useRef(closeActivity);

    React.useEffect(() => {
        requestPayloadRef.current["ActivityId"] = props.activityId;
        requestPayloadRef.current["isSystemNote"] = true;
        requestPayloadRef.current["actionType"] = props.type;

        dispatch(getActivityOpenDiaries({ activityId: props.activityId, uId: LOGGED_IN_USER_ID }));
        dispatch(getActivityNotifications({ activityId: props.activityId, uId: LOGGED_IN_USER_ID }));

        return () => { dispatch(resetCloseActivityState()); };
    }, []);

    React.useEffect(() => {
        const prev = prevCloseActivityRef.current;
        if (closeActivity.diariesData && closeActivity.diariesData.data.length && !closingItems[0].count) {
            let tmp = closingItems.slice();
            tmp[0].count = closeActivity.diariesData.data.length;
            const extractedData = getIdsArrAndModifiedObj(closeActivity.diariesData.data);
            diaryMasterDataRef.current = extractedData.obj;
            setClosingItems(tmp);
            setSelectedDiaries(extractedData.idArr);
            setDiariesData(diaryMasterDataRef.current);
        }
        if (closeActivity.notificationData.data.length && !closingItems[1].count) {
            let tmp = closingItems.slice();
            tmp[1].count = closeActivity.notificationData.data.length;
            const extractedData = getIdsArrAndModifiedObj(closeActivity.notificationData.data);
            notificationMasterDataRef.current = extractedData.obj;
            setClosingItems(tmp);
            setSelectedNotification(getIdsArrAndModifiedObj(closeActivity.notificationData.data).idArr);
        }
        if (closeActivity.errorMsg) {
            setCloseActivityConfimationMessage(null);
            setCloseActivityWarningMessage(null);
            setCloseActivityErrorMessage(closeActivity.errorMsg);
        }
        prevCloseActivityRef.current = closeActivity;
    }, [closeActivity]);

    React.useEffect(() => {
        let modalDiv = document.querySelector(".ReactModal__Content");
        removeClass(modalDiv, "confirmModal");
        if (mobileAndTabletcheck() && closeActivityConfimationMessage) {
            addClass(modalDiv, "confirmModal");
        } else if (closeActivityConfimationMessage) {
            removeClass(modalDiv, "large");
            removeClass(modalDiv, "fullView");
            removeClass(modalDiv, "modalAlignFromTop");
            addClass(modalDiv, "medium");
            addClass(modalDiv, "confirmModal");
        } else if (!mobileAndTabletcheck()) {
            removeClass(modalDiv, "medium");
            addClass(modalDiv, "large");
            addClass(modalDiv, "fullView");
            addClass(modalDiv, "modalAlignFromTop");
        }
    }, [closeActivityConfimationMessage]);

    const onTabClick = (tabKey) => { setSelectedTab(tabKey); };

    const handleMultiDiaryCheckBoxClick = (data) => {
        if (!data.checked) {
            setSelectedDiaries(getIdsArrAndModifiedObj(closeActivity.diariesData.data).idArr);
        } else {
            setSelectedDiaries([]);
        }
    };

    const handleMultiNotificationCheckBoxClick = (data) => {
        if (!data.checked) {
            setSelectedNotification(getIdsArrAndModifiedObj(closeActivity.notificationData.data).idArr);
        } else {
            setSelectedNotification([]);
        }
    };

    const handleDiaryCheckboxClick = (data) => {
        let tmpDiaryArr = selectedDiaries.slice();
        const index = tmpDiaryArr.indexOf(parseInt(data.Id));
        if (!data.checked && index == -1) { tmpDiaryArr.push(parseInt(data.Id)); }
        else if (index >= -1) { tmpDiaryArr.splice(index, 1); }
        setSelectedDiaries(tmpDiaryArr);
    };

    const handleNotificationCheckboxClick = (data) => {
        let tmpDiaryArr = selectedNotification.slice();
        const index = tmpDiaryArr.indexOf(parseInt(data.Id));
        if (!data.checked && index == -1) { tmpDiaryArr.push(parseInt(data.Id)); }
        else if (index >= -1) { tmpDiaryArr.splice(index, 1); }
        setSelectedNotification(tmpDiaryArr);
    };

    const updateDiariesData = (tmpObj) => {
        const tmp = Object.assign({}, diariesData, { [tmpObj.Id]: tmpObj });
        diaryMasterDataRef.current = tmp;
        setDiariesData(tmp);
    };

    const onDiaryTitleEditCLick = (title, id) => {
        if (title === "") return dispatch(hideTooltip());
        let tmpObj = Object.assign({}, diariesData[id], { Title: title });
        const payload = { cid: id, title, todoId: id };
        dispatch(changeDiarieTitle(payload));
        updateDiariesData(tmpObj);
        setEditDiaryTitle(0);
    };

    const onDiaryDueDateEditCLick = (event, item) => {
        dispatch(showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: true,
            showOnClick: true,
            toolTipClassName: 'toolTipCommentBox',
            childComponent: <DiaryEditDueDateComp onSaveBtnClick={onDiaryDueDateSaveClick} onCancelBtnClick={() => dispatch(hideTooltip())} data={item} />
        }));
    };

    const onDiaryDueDateSaveClick = (data, payload) => {
        dispatch(hideTooltip());
        let tmpObj = Object.assign({}, diariesData[data.Id], data);
        dispatch(changeDiarieDueDate(payload));
        updateDiariesData(tmpObj);
    };

    const onSuccess = (status) => {
        if (status == ErrorCode.Success) {
            dispatch(hideDialogueBox());
        } else if (status == ErrorCode.ActionDenied) {
            setIsActionDenied(true);
            setActionDeniedMsg(closeActivity.actionDeniedMsg);
        }
    };

    const onContinueClick = () => {
        let diariesDataArr = [];
        if (selectedDiaries.length) {
            selectedDiaries.map((dId) => {
                diaryMasterDataRef.current[dId]["Checked"] = true;
                diariesDataArr.push(diaryMasterDataRef.current[dId]);
            });
        }
        tmpRef.current = Object.assign({}, {
            close_activity_data: requestPayloadRef.current,
            diaries_data: diariesDataArr,
            notification_data: { status: 2, activityUpdateIds: selectedNotification.join(','), resetCounter: false },
            callback: (status) => onSuccess(status)
        });
        setCloseActivityConfimationMessage("Are you sure you want to close this activity?");
    };

    const onConfirmButtonClick = () => {
        if ((props.type === "closeMidTerm" && userPermission?.can_close_activity_during_mid_term) ||
            (props.type === "close" && userPermission?.can_close_activity)) {
            dispatch(closeActivityFromWeb(tmpRef.current));
        } else {
            setCloseActivityConfimationMessage(null);
            setCloseActivityWarningMessage(CLOSE_ACTIVITY_ERROR_VALIDATION_MESSAGE.warningMessage);
        }
    };

    const onConfirmErrorMsgClick = () => {
        setCloseActivityWarningMessage(null);
        setCloseActivityErrorMessage(null);
        dispatch(hideDialogueBox());
    };

    const onClose = () => { dispatch(hideDialogueBox()); };

    const onEditClick = (event, data) => {
        dispatch(showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: true,
            showOnClick: true,
            isUpdatableWidth: true,
            childComponent: <EditableHeading
                isEditable
                allowBlank={true}
                heading={data.Title}
                id={data.Id}
                onHeadingEdited={onDiaryTitleEditCLick}
                isOpen={true}
                editableHeadingCancelClick={() => dispatch(hideTooltip())}
            />
        }));
    };

    const renderTabs = () => (
        <div className="tabNav">
            <div className="tabs">
                {closingItems.map((item, index) => {
                    let showtabs = (!isMobile() || (item.key == selectedTab));
                    return (
                        <a key={item.key} href="javascript:void(0);" className={classNames({ active: (item.key == selectedTab) })} onClick={(e) => { onTabClick(item.key); }}>
                            <Icon name={item.iconName} className="icon" />
                            {showtabs && <>
                                {item.title}
                                <span className="count"> &nbsp; ({item.count}) </span>
                            </>}
                        </a>
                    );
                })}
            </div>
        </div>
    );

    const renderOpenDiaries = () => {
        const tempDiaries = diariesData;
        return (
            (tempDiaries && Object.keys(tempDiaries).length)
                ?
                (
                    <div className="" id="dvOpenDiaries">
                        <div className="headSticky rowSpaceBetween alignMiddle">
                            <div className="checkboxGlobal">
                                <div className="activityTitle"><CheckBox handleCheckbox={handleMultiDiaryCheckBoxClick} item={{ checked: selectedDiaries.length === closeActivity.diariesData.data.length }} /></div>
                                <div className="selected_items_heading_txt alignMiddle"><FormattedMessage id="close_activity.heading" defaultMessage={defaultJSON['close_activity.heading']} /></div>
                            </div>
                            <span className="dueDate"><FormattedMessage id="due_date_label" defaultMessage={defaultJSON['due_date_label']} /></span>
                        </div>
                        <ul className="scrollArea">
                            {Object.keys(tempDiaries).map((itemId, index) => {
                                const tmp = tempDiaries[itemId];
                                return (
                                    <li className="alignStart dFlex" key={tmp.Id}>
                                        <div className="activityTitle"><CheckBox cssClass={"activityStart"} key={tmp.Id} item={getItem(tmp, selectedDiaries)} handleCheckbox={handleDiaryCheckboxClick} /></div>
                                        <div className="openDiariesSummary flexGrow activityEdit">
                                            <div className="rowFlex alignMiddle">
                                                {editDiaryTitle && editDiaryTitle == tmp.Id ?
                                                    <EditableHeading allowBlank={true} headingRequired={true} isEditable={true} id={tmp.Id} heading={tmp.Title} onHeadingEdited={onDiaryTitleEditCLick} isOpen={true} editableHeadingCancelClick={() => setEditDiaryTitle(0)} /> :
                                                    <span className="" title={tmp.Title}>{tmp.Title.length > openDiaryTitle.maxLengthToTruncate ? tmp.Title.substring(openDiaryTitle.startIndexOfSubstringTruncate, openDiaryTitle.endIndexOfSubstringTruncate) + "..." : tmp.Title}
                                                        <span className="iconRipple ml mr"><a className="pointer flexGrow" onClick={(e) => { setEditDiaryTitle(tmp.Id); }}><Icon name="editActive" className="icon mr ml ttController" /></a></span>
                                                    </span>
                                                }
                                            </div>
                                            <label>
                                                <DiaryEditDueDateComp onSaveBtnClick={onDiaryDueDateSaveClick} className={"react-datepicker__triangle animated faster fadeInUpx2"} data={tmp} />
                                            </label>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )
                :
                (<div className="error_m alignMiddle"><div className="emptyScreen noDataFound"><Icon name="Emptydiary" className="" /><label><FormattedMessage id="close_activity.error" defaultMessage={defaultJSON['close_activity.error']} /></label></div></div>)
        );
    };

    const renderNotification = () => {
        const $ = window.jQuery;
        const auTemplates = window.auTemplates;
        return (
            (closeActivity && closeActivity.notificationData && closeActivity.notificationData.data && closeActivity.notificationData.data.length)
                ?
                (
                    <div id="dvUnreadNotifications" className="">
                        <div className="headSticky">
                            <div className="checkboxGlobal">
                                <div className="activityTitle"><CheckBox handleCheckbox={handleMultiNotificationCheckBoxClick} item={{ checked: selectedNotification.length === closeActivity.notificationData.data.length }} /></div>
                                <div className=""><FormattedMessage id="close_activity.mark_heading" defaultMessage={defaultJSON['close_activity.mark_heading']} /></div>
                            </div>
                        </div>
                        <ul className="scrollArea">
                            {closeActivity.notificationData.data.map((item, index) => (
                                <li className="dFlex" key={item.Id}>
                                    <div className="activityTitle"><CheckBox cssClass={"activityStart"} key={item.Id} item={getItem(item, selectedNotification)} handleCheckbox={handleNotificationCheckboxClick} /></div>
                                    <div className='openAssign flexGrow colFlex'>
                                        <div className="rowSpaceBetween flexGrow">
                                            <NotificationCell data={item} extraData={{ displayMarkReadIcon: false, displayProfilePic: false, displayTriggerByName: false }} onCellClick={() => false} />
                                            <div className="rowFlex posBottom alignRight activityUser" onClick={() => setOwnerassigneeinfokey(index)} onMouseLeave={() => setOwnerassigneeinfokey(-1)}>
                                                {(isMobile() && ownerassigneeinfokey == index) &&
                                                    <div className="exz-tooltip" key={index}>
                                                        <div className="colFlex">
                                                            <div className="userInfo  alignMiddle">
                                                                <UserImage profileUrl={item.TriggeredByProfileImage} size="32" profileName={`${item.TriggeredByFullName.split(' ')[0]} ${item.TriggeredByFullName.split(' ')[1]}`} />
                                                                <span className="ml"><span className="name">{item.TriggeredByFullName}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className="badges badgesSmall">
                                                    <UserImage profileUrl={item.TriggeredByProfileImage} size="24" profileName={`${item.TriggeredByFullName.split(' ')[0]} ${item.TriggeredByFullName.split(' ')[1]}`} />
                                                    <span className="activityCreator">{item.TriggeredByFullName}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )
                :
                (<div className="error_m alignMiddle"><div className="emptyScreen noDataFound"><Icon name="Emptyowner" className="" /><label><FormattedMessage id="close_activity.no_notification" defaultMessage={defaultJSON['close_activity.no_notification']} /></label></div></div>)
        );
    };

    const renderCommentBox = () => (
        <div className="commentSticky colFlex">
            <textarea onChange={(e) => { requestPayloadRef.current["txtareaAddNote"] = e.target.value; }} placeholder="Any comment here will be added to activity being closed."></textarea>
            <div className="rowFlex alignRight alignMiddle mt__1 mb">
                <button className="btn buttonGradient" onClick={onContinueClick}>Continue</button>
                <button className="btn link mrNone" type="button" onClick={onClose}>Cancel</button>
            </div>
        </div>
    );

    const modalDiv = document.querySelector(".ReactModal__Content");
    if (isActionDenied) {
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    message={actionDeniedMsg}
                    onConfirmClick={() => { setActionDeniedMsg(""); setIsActionDenied(false); dispatch(hideDialogueBox()); }}
                    header={"Cannot Close Activity!"}
                    confirmationText={"Close"}
                    hideCancel={true}
                />
            </div>
        );
    }
    if (closeActivityConfimationMessage) {
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    message={closeActivityConfimationMessage}
                    onConfirmClick={() => onConfirmButtonClick()}
                    onCancelClick={() => setCloseActivityConfimationMessage(null)}
                    bothButton={true}
                    middleText={''}
                />
            </div>
        );
    }
    if (closeActivityWarningMessage) {
        addClass(modalDiv, "confirmModal");
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    message={closeActivityWarningMessage}
                    confirmationText={"Okay"}
                    hideCancel={true}
                    onConfirmClick={() => { onConfirmErrorMsgClick(); }}
                />
            </div>
        );
    }
    if (closeActivityErrorMessage) {
        addClass(modalDiv, "confirmModal");
        return (
            <div className="row-fluid" style={{ display: "table" }}>
                <ConfirmationTextBox
                    class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                    message={closeActivityErrorMessage}
                    confirmationText={"Okay"}
                    hideCancel={true}
                    onConfirmClick={() => { onConfirmErrorMsgClick(); }}
                />
            </div>
        );
    }
    return (
        <>
            <div className="modalHeader alignMiddle CloseHeader">
                <h1>{MiddlePanelConstant.CloseActivityText}</h1>
                <a className="alignMiddle alignRight Close" href="javascript:void(0)" onClick={onClose}><Icon name="close" className="icon mr" /></a>
            </div>
            <div className="modalBody container close_activity_popup closeWorkkardPopup">
                <div className="info_txt toast toastList"><Icon name="info" className="icon mr" /><FormattedMessage id="close_activity.info_txt" defaultMessage={defaultJSON['close_activity.info_txt']} />
                </div>
                {renderTabs()}
                <div className="ModalinnerContainer">
                    {(selectedTab == "diary") && renderOpenDiaries()}
                    {(selectedTab == "notification") && renderNotification()}
                </div>
                {renderCommentBox()}
            </div>
        </>
    );
};

export default CloseActivity;